import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AnteaCredentialsDialogComponent } from './antea-credentials-dialog/antea-credentials-dialog.component';
import { AnteaService } from '../../../services/antea.service';

@Component({
  selector: 'ebw-monorepo-trasmissione-antea',
  templateUrl: './trasmissione-antea.component.html',
  styleUrls: ['./trasmissione-antea.component.scss']
})
export class TrasmissioneAnteaComponent implements OnInit {
  public token$: Observable<string | null> = this._anteaService.token$;

  constructor(
    private _dialog: MatDialog,
    private _anteaService: AnteaService
  ) {}

  ngOnInit(): void {
    if (!this._anteaService.token) {
      this.openCredentialsDialog();
    }
  }

  public openCredentialsDialog(): void {
    this._dialog.open(AnteaCredentialsDialogComponent, { width: '400px', disableClose: true });
  }
}
